RivalIQ.apps.LandscapeSettings.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Email = Backbone.Collection.extend({
        model: RivalIQ.apps.LandscapeSettings.models.Email
    });

    collections.Email.createFromSettings = function (emailSettings) {
        const additionalAddresses = (emailSettings && emailSettings.additionalAddresses ? emailSettings.additionalAddresses : []);

        const emails = _.map(additionalAddresses || [], function (email) {
            return {
                email: email
            };
        });

        return new RivalIQ.apps.LandscapeSettings.collections.Email(emails);
    };
});
